import { ColorName, COLORS } from '@connect-x-app/shared-ui';
import { getHoursFromSeconds } from '@connect-x-app/shared-utils';

interface FormattedTimeBefore {
  color: ColorName;
  timeBefore: string;
}

export const getFormattedTimeBefore = (
  timeInSeconds: number | undefined | null,
  cellNotAvalailableValueTranslation: string,
): FormattedTimeBefore => {
  const isValidNumericValue = typeof timeInSeconds === 'number' && Number.isFinite(timeInSeconds);

  if (isValidNumericValue) {
    return {
      color: COLORS.zulu.$06,
      timeBefore: `${getHoursFromSeconds(timeInSeconds)}`,
    };
  }

  return {
    color: COLORS.zulu.$02,
    timeBefore: cellNotAvalailableValueTranslation,
  };
};
